var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.33 8.08697C17.3132 4.0364 13.2053 1.57705 9.15479 2.59384C5.98937 3.38846 3.69092 6.12428 3.4541 9.37928C1.20652 9.74993 -0.31505 11.8724 0.0556011 14.12C0.385092 16.1181 2.11646 17.5814 4.14152 17.5734H7.57865V16.1985H4.14152C2.62292 16.1985 1.39183 14.9674 1.39183 13.4488C1.39183 11.9302 2.62292 10.6991 4.14152 10.6991C4.5212 10.6991 4.82895 10.3914 4.82895 10.0117C4.82551 6.59483 7.5927 3.8221 11.0096 3.8187C13.9674 3.81574 16.5136 5.9068 17.0857 8.80872C17.1422 9.09847 17.3774 9.31982 17.67 9.35866C19.5494 9.62628 20.8559 11.3667 20.5883 13.246C20.348 14.9335 18.9072 16.19 17.2026 16.1985H14.4529V17.5734H17.2026C19.8602 17.5654 22.008 15.4044 22 12.7468C21.9933 10.5346 20.479 8.61194 18.33 8.08697Z",
    fill: "#66676F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5278 10.8986L7.77808 13.6483L8.74735 14.6176L10.3284 13.0434V19.6358H11.7033V13.0434L13.2775 14.6176L14.2467 13.6483L11.497 10.8986C11.2289 10.6321 10.7959 10.6321 10.5278 10.8986Z",
    fill: "#66676F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "assets/media/upload-icon.5a41d2a8b2cc75f6e73e551ed8861e2a.svg";
export { ForwardRef as ReactComponent };